interface LevelInfo {
    level: number;
    currentLevelMinXp: number;  // Minimum XP needed for this level (inclusive)
    currentLevelMaxXp: number;  // Maximum XP needed for this level (inclusive)
    totalXp: number;           // The input XP value
  }
  
  const BASE_XP = 100;         // XP needed to go from level 1 to 2
  const GROWTH_RATE = 1.5;     // XP growth multiplier per level
  const MAX_LEVEL = 100;       // Maximum achievable level
  
  // Pre-calculate all level requirements
  const levelRequirements: { minXp: number, xpToNext: number }[] = (() => {
    const requirements = [];
    let minXp = 0;
    let xpToNext = BASE_XP;
    
    for (let level = 1; level <= MAX_LEVEL; level++) {
      requirements.push({ minXp, xpToNext });
      minXp += xpToNext;
      xpToNext = Math.floor(BASE_XP * Math.pow(GROWTH_RATE, level));
    }
    
    return requirements;
  })();
  
  export function getLevelFromXp(currentXp: number): LevelInfo {
    // Handle negative XP (treat as 0)
    if (currentXp < 0) currentXp = 0;
    
    // Check for max level
    if (currentXp >= levelRequirements[MAX_LEVEL - 1].minXp) {
      return {
        level: MAX_LEVEL,
        currentLevelMinXp: levelRequirements[MAX_LEVEL - 1].minXp,
        currentLevelMaxXp: Infinity,
        totalXp: currentXp
      };
    }
    
    // Find the correct level
    for (let i = 1; i < MAX_LEVEL; i++) {
      if (currentXp < levelRequirements[i].minXp) {
        return {
          level: i,
          currentLevelMinXp: levelRequirements[i - 1].minXp,
          currentLevelMaxXp: levelRequirements[i].minXp - 1,
          totalXp: currentXp
        };
      }
    }
    
    // Default case (level 1)
    return {
      level: 1,
      currentLevelMinXp: 0,
      currentLevelMaxXp: levelRequirements[0].xpToNext - 1,
      totalXp: currentXp
    };
  }
  
  // Helper function to calculate XP needed for next level if needed
  export function getXpToNextLevel(currentXp: number): number {
    const levelInfo = getLevelFromXp(currentXp);
    if (levelInfo.level === MAX_LEVEL) return Infinity;
    return levelInfo.currentLevelMaxXp - currentXp + 1;
  }